import { render, staticRenderFns } from "./StoppingArea.vue?vue&type=template&id=4f67c23c&scoped=true&"
import script from "./StoppingArea.vue?vue&type=script&lang=js&"
export * from "./StoppingArea.vue?vue&type=script&lang=js&"
import style0 from "./StoppingArea.vue?vue&type=style&index=0&id=4f67c23c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f67c23c",
  null
  
)

export default component.exports